import React from "react";
import "./login.css";

const Index = () => {
  return <form>
    
  </form>
};

export default Index;
